// hooks/organization/context.js
import { createContext, useContext, useReducer } from 'react';
import { organizationReducer, initialState } from './reducer';

const OrganizationContext = createContext();

export const OrganizationProvider = ({ children }) => {
    const [state, dispatch] = useReducer(organizationReducer, initialState);

    return <OrganizationContext.Provider value={[state, dispatch]}>{children}</OrganizationContext.Provider>;
};

export const useOrganisationContext = () => {
    const context = useContext(OrganizationContext);
    if (!context) {
        throw new Error('useOrganisationContext must be used within a OrganizationProvider');
    }
    return context;
};
